customElements.define('keene-mobile-nav', class extends HTMLElement {
  connectedCallback() {
    this.renderCount = (cart) => {
      if (!Number.isFinite(cart?.item_count)) return;
      const count = Math.max(0, cart.item_count);
      const badge = this.querySelector('[data-keene-mobile-cart-count]');
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      this.querySelector('[data-keene-mobile-cart]').setAttribute('aria-label', `${this.dataset.cartLabel}: ${count}`);
    };
    this.onUpdate = (event) => this.renderCount(event.detail?.cart);
    this.unsubscribe = window.FoxTheme?.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => this.renderCount(cart));
    for (const name of ['cart:updated', 'keene:cart-updated']) document.addEventListener(name, this.onUpdate);
    this.onPageShow = () => fetch(`${window.KeeneCartGuard.root()}cart.js`, { cache: 'no-store' }).then((r) => r.ok ? r.json() : null).then(this.renderCount).catch(() => {});
    window.addEventListener('pageshow', this.onPageShow);
    this.resize = new ResizeObserver(() => {
      const height = this.getBoundingClientRect().height;
      if (height) document.documentElement.style.setProperty('--keene-nav-height', `${Math.ceil(height)}px`);
    });
    this.resize.observe(this);
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    for (const name of ['cart:updated', 'keene:cart-updated']) document.removeEventListener(name, this.onUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
    this.resize?.disconnect();
  }
});
